export interface RouteEditSessionHandler {
  canHandleRoutePointDelete: (tourId: string, routePointIndex: number) => boolean
  deleteRoutePoint: (tourId: string, routePointIndex: number) => Promise<boolean>
}

const handlers = new Set<RouteEditSessionHandler>()

export function registerRouteEditSessionHandler(handler: RouteEditSessionHandler): () => void {
  handlers.add(handler)
  return () => {
    handlers.delete(handler)
  }
}

export async function tryDeleteRoutePointViaSession(
  tourId: string,
  routePointIndex: number,
): Promise<boolean | null> {
  const activeHandlers = Array.from(handlers)
  for (let index = activeHandlers.length - 1; index >= 0; index--) {
    const handler = activeHandlers[index]
    if (!handler.canHandleRoutePointDelete(tourId, routePointIndex)) continue
    return handler.deleteRoutePoint(tourId, routePointIndex)
  }

  return null
}
